import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { AllValues } from '@/utils/types/types.util';
import { RiPermissions, CorePermissions } from '@/constants/permissions.constant';
import {
  loadCorePermissionsFromStorage,
  loadRiPermissionsFromStorage,
} from '@/utils/storage/permissions.storage';

type RiPermissionValue = AllValues<typeof RiPermissions>;
type RiPermissionsStore = {
  riPermissions: RiPermissionValue[];
  setRiPermissions: (permissions: RiPermissionValue[]) => void;
};
const useRiPermissionsStore = create(
  devtools<RiPermissionsStore>((set) => ({
    riPermissions: loadRiPermissionsFromStorage(),
    setRiPermissions: (riPermissions) => {
      set({ riPermissions });
    },
  })),
);

type CorePermissionValue = AllValues<typeof CorePermissions>;
type CorePermissionsStore = {
  corePermissions: CorePermissionValue[];
  setCorePermissions: (permissions: CorePermissionValue[]) => void;
};
const useCorePermissionsStore = create(
  devtools<CorePermissionsStore>((set) => ({
    corePermissions: loadCorePermissionsFromStorage(),
    setCorePermissions: (corePermissions) => {
      set({ corePermissions });
    },
  })),
);

export { useRiPermissionsStore, useCorePermissionsStore };
